import { combineReducers } from "redux";
import newProductReducer from "./newProductReducer";

export const homeReducers = {
  home: combineReducers({
    newProducts: newProductReducer,
  }),
};
